import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import './Modal.css';

// const API_BASE_URL = process.env.REACT_APP_BASE_DOMAIN;
const API_BASE_URL = '';

const ReservationDetails = ({ reservation, onClose, onDelete, onEdit }) => {
    const { t, i18n } = useTranslation();
    const currentDir = i18n.dir();
    const [error, setError] = useState(null);
    const [isDeleting, setIsDeleting] = useState(false);

    // Handle Escape key to close modal
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [onClose]);

    // Format the times using the reservation data
    const startTime = reservation.occurrence_start
      ? moment(reservation.occurrence_start).format('YYYY-MM-DD HH:mm')
      : `${reservation.date} ${reservation.startTime}`;
    const endTime = reservation.occurrence_end
      ? moment(reservation.occurrence_end).format('YYYY-MM-DD HH:mm')
      : `${reservation.date} ${reservation.endTime}`;

    const handleDelete = async () => {
        try {
            setIsDeleting(true);
            const token = localStorage.getItem('token');
            const deleteUrl = `${API_BASE_URL}/api/reservations/${reservation.id}/`;
            // console.log('Delete URL:', deleteUrl);
            // console.log('Reservation:', reservation);

            await axios.delete(deleteUrl, {
                headers: {
                    'Authorization': `Token ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            onDelete();
            onClose();
        } catch (error) {
            console.error('Delete error:', error);
            console.error('Error response:', error.response);
            setError(error.response?.data?.detail ||  error.response?.data?.non_field_errors || t('details_delete_error'));
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-card" dir={currentDir}>
                <h2 style={{ marginTop: 0, marginBottom: '20px', color: 'var(--text)' }}>
                    {t('details_title')}
                </h2>

                {error && (
                    <div
                        className="card"
                        style={{
                            background: 'color-mix(in oklab, var(--color-danger) 12%, var(--surface))',
                            color: 'var(--text)',
                            border: '1px solid',
                            borderColor: 'color-mix(in oklab, var(--color-danger) 35%, var(--border))',
                            padding: '10px',
                            borderRadius: '5px',
                            marginBottom: '15px'
                        }}
                    >
                        {error}
                    </div>
                )}

                <div style={{ marginBottom: '15px' }}>
                    <strong>{t('details_title_label')}</strong> {reservation.title}
                </div>

                <div style={{ marginBottom: '15px' }}>
                    <strong>{t('details_reserved_by')}</strong> {reservation.userName}
                </div>

                <div style={{ marginBottom: '15px' }}>
                    <strong>{t('details_description')}</strong> {reservation.description || t('details_no_description')}
                </div>

                {reservation.recurring && (
                    <div style={{ marginBottom: '15px' }}>
                        <strong>{t('details_recurrence')}</strong> {reservation.recurring}
                    </div>
                )}

                <div style={{ marginBottom: '15px' }}>
                    <strong>{t('details_start_time')}</strong> {startTime}
                </div>

                <div style={{ marginBottom: '15px' }}>
                    <strong>{t('details_end_time')}</strong> {endTime}
                </div>

                <div className="modal-actions">
                    <button onClick={onClose} className="btn btn-secondary">{t('details_close')}</button>
                    {reservation.can_edit ? (
                        <button onClick={() => onEdit && onEdit(reservation)} className="btn btn-primary">{t('details_edit')}</button>
                    ) : (
                        console.log('Permission denied: User cannot edit this reservation') || null
                    )}
                    {reservation.can_delete ? (
                        <button onClick={handleDelete} disabled={isDeleting} className="btn btn-danger">
                            {isDeleting ? t('details_deleting') : t('details_delete')}
                        </button>
                    ) : (
                        console.log('Permission denied: User cannot delete this reservation') || null
                    )}
                </div>
            </div>
        </div>
    );
};

export default ReservationDetails;
